import { render, staticRenderFns } from "./tableTemplate.vue?vue&type=template&id=68aa87ce"
import script from "./tableTemplate.vue?vue&type=script&lang=js"
export * from "./tableTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports